var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "followNews" }, [
        _c("div", { staticClass: "basic-information-title" }, [
          _vm._v("跟进信息")
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.showCC == true && _vm.hasFollowCreated && _vm.userExId != null
            ? _c("img", {
                staticClass: "newlyAddImg",
                staticStyle: { "margin-right": "0.2rem" },
                attrs: {
                  src: require("@/assets/img/contact.png"),
                  alt: "",
                  srcset: ""
                },
                on: {
                  click: function($event) {
                    return _vm.openUserProfile()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCC == true && _vm.hasFollowCreated
            ? _c("img", {
                staticClass: "newlyAddImg",
                staticStyle: { "margin-right": "0.2rem" },
                attrs: {
                  src: require("@/assets/img/newlyAdd.png"),
                  alt: "",
                  srcset: ""
                },
                on: {
                  click: function($event) {
                    return _vm.redact(1)
                  }
                }
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "product-list" },
            _vm._l(_vm.list, function(item, index) {
              return _c("div", { key: index }, [
                _c("div", { staticClass: "flex product-list-header" }, [
                  _c("div", { staticClass: "flex center" }, [
                    _c("img", {
                      staticClass: "camera",
                      attrs: {
                        src: require("@/assets/img/camera.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-name" }, [
                      _vm._v("门店-" + _vm._s(item.deptName || ""))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    item.followResult == "" && _vm.showCC == true
                      ? _c(
                          "div",
                          {
                            staticClass: "plan-noSuccess",
                            on: {
                              click: function($event) {
                                return _vm.noSuccess(item.id)
                              }
                            }
                          },
                          [_vm._v("计划未完成")]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "product-list-content" }, [
                  _c(
                    "div",
                    {
                      staticClass: "basic-information-flex",
                      class: item.edit == true ? "active" : "activeno"
                    },
                    [
                      _c("ul", { staticClass: "basic-information-lists" }, [
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("计划日期")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.plannedDate || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("计划备注")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.planedRemark || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("计划方式")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.plannedWayName || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("提交人")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.salesName || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("跟进日期")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.followDate || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("跟进人")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.followUserName || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("跟进方式")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.followTypeName || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("跟进结果")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.followResultName || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("所属门店")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.deptName || ""))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-item" },
                            [_vm._v("跟进备注")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "basic-information-lists-text" },
                            [_vm._v(_vm._s(item.followRemark || ""))]
                          )
                        ])
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex packUp center",
                    on: {
                      click: function($event) {
                        return _vm.packUp(index)
                      }
                    }
                  },
                  [
                    item.edit == true
                      ? _c("img", {
                          staticClass: "arrow",
                          attrs: {
                            src: require("@/assets/img/upArrow1.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item.edit == false
                      ? _c("img", {
                          staticClass: "arrow",
                          attrs: {
                            src: require("@/assets/img/dowmArrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n        " +
                        _vm._s(item.edit == true ? "收起详情" : "展开详情") +
                        "\n      "
                    )
                  ]
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c("van-actionsheet", {
        attrs: { actions: _vm.actions, "cancel-text": "取消" },
        on: { select: _vm.onSelect, cancel: _vm.onCancel },
        model: {
          value: _vm.sheetShow,
          callback: function($$v) {
            _vm.sheetShow = $$v
          },
          expression: "sheetShow"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-model" },
        [
          _c(
            "van-popup",
            {
              attrs: { overlay: true, "close-on-click-overlay": false },
              model: {
                value: _vm.productShow,
                callback: function($$v) {
                  _vm.productShow = $$v
                },
                expression: "productShow"
              }
            },
            [
              _c("div", { staticClass: "model-height" }, [
                _c("div", { staticClass: "product-title" }, [
                  _vm._v("新增计划及跟进")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "basic-models-list" }, [
                  _c("div", { staticClass: "followNews" }, [
                    _c("div", { staticClass: "basic-information-title " }, [
                      _vm._v("计划信息")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c(
                      "div",
                      { staticClass: "models-list-item-title titles" },
                      [_vm._v("计划日期")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.status == false ? _vm.downSelections(0) : ""
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullListA[0]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c(
                      "div",
                      { staticClass: "models-list-item-title titles" },
                      [_vm._v("计划")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.status == false ? _vm.downSelections(1) : ""
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullListA[1]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "remark-title" }, [
                    _c("div", { staticClass: "remark-titles titles" }, [
                      _vm._v("备注")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "textareas" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pullListA[2]["name"],
                            expression: "pullListA[2]['name']"
                          }
                        ],
                        attrs: {
                          name: "",
                          id: "",
                          cols: "30",
                          rows: "10",
                          disabled: _vm.status,
                          oninput:
                            "if(value.length>1024)value=value.slice(0,1024)"
                        },
                        domProps: { value: _vm.pullListA[2]["name"] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.pullListA[2],
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "followNews" }, [
                    _c("div", { staticClass: "basic-information-title" }, [
                      _vm._v("跟进信息")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c(
                      "div",
                      { staticClass: "models-list-item-title titles" },
                      [_vm._v("跟进日期")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            return _vm.downSelections(3)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullListB[0]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c(
                      "div",
                      { staticClass: "models-list-item-title titles" },
                      [_vm._v("跟进方式")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            return _vm.downSelections(4)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullListB[1]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c(
                      "div",
                      { staticClass: "models-list-item-title titles" },
                      [_vm._v("跟进结果")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            return _vm.downSelections(5)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullListB[2]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "remark-title" }, [
                    _c("div", { staticClass: "remark-titles titles" }, [
                      _vm._v("备注")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "textareas" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pullListB[3]["name"],
                            expression: "pullListB[3]['name']"
                          }
                        ],
                        attrs: {
                          name: "",
                          id: "",
                          cols: "30",
                          rows: "10",
                          oninput:
                            "if(value.length>1024)value=value.slice(0,1024)"
                        },
                        domProps: { value: _vm.pullListB[3]["name"] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.pullListB[3],
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c(
                  "div",
                  { staticClass: "button-flex-color flex-border-button" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button-flex-item",
                        on: { click: _vm.cancelFollw }
                      },
                      [_vm._v("取消")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item button-active",
                      on: { click: _vm.confirmFollw }
                    },
                    [_vm._v("确定")]
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { width: "100%" },
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.timeShow,
            callback: function($$v) {
              _vm.timeShow = $$v
            },
            expression: "timeShow"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              "min-date": _vm.minDate,
              "max-date": _vm.maxDate
            },
            on: { confirm: _vm.timeConfirm, cancel: _vm.timeCancel },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showDownSelection,
            callback: function($$v) {
              _vm.showDownSelection = $$v
            },
            expression: "showDownSelection"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.downSelection,
              "value-key": "name"
            },
            on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f9fb6f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f9fb6f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/followNews.vue
// module id = null
// module chunks = 